"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getTransition = void 0;

var getIconDim = function getIconDim(value) {
  if (value === 'small') return '40px';
  if (value === 'medium') return '60px';
  return '80px';
};

var camelCaseToKebabCase = function camelCaseToKebabCase(key) {
  var modifiedString = key.split('').map(function (char) {
    return "".concat(char.toLowerCase() !== char ? '-' : '').concat(char.toLowerCase());
  }).join('');
  return modifiedString;
};

var handleParseKey = function handleParseKey(key, attribute) {
  if (attribute) {
    if (key === 'backgroundImage') {
      return "background-image: url(".concat(attribute, "); ");
    }

    if (key === 'iconSize') {
      return "\n          height: ".concat(getIconDim(attribute), ";\n          width: ").concat(getIconDim(attribute), ";\n      ");
    }

    if (key === 'fontColor') {
      return "\n          color: ".concat(attribute, ";\n      ");
    }

    if (key === 'size') {
      return "\n        height: ".concat(attribute, ";\n        width: ").concat(attribute, ";\n      ");
    }

    var val = "".concat(camelCaseToKebabCase(key), ": ").concat(attribute);
    return "".concat(val, ";");
  }

  return '';
};

var getStyle = function getStyle(config) {
  var keys = Object.keys(config || {});
  var style = keys.reduce(function (sum, key) {
    return "".concat(sum, "\n      ").concat(handleParseKey(key, config[key]));
  }, '');
  return style;
};

var getTransition = function getTransition(time, ease) {
  var cssProperty = ['opacity', 'width', 'height', 'background-color', 'border', 'border-radius', 'box-shadow', 'visibility'];
  var showTransition = cssProperty.map(function (item) {
    if (item === 'opacity') {
      return "opacity ".concat(time, " ease-out");
    }

    return "".concat(item, " ").concat(time, " ").concat(ease, " ");
  }).join(', ');
  var hideTransition = cssProperty.map(function (item) {
    if (item === 'opacity') {
      return "opacity ease-in ".concat(time);
    }

    return "".concat(item, " ").concat(time, " ").concat(ease);
  }).join(', ');
  return {
    showTransition: showTransition,
    hideTransition: hideTransition
  };
};

exports.getTransition = getTransition;
var _default = getStyle;
exports.default = _default;